import { render } from "./WebInfoPage.vue?vue&type=template&id=73e78010"
import script from "./WebInfoPage.vue?vue&type=script&lang=js"
export * from "./WebInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__